// extracted by mini-css-extract-plugin
module.exports = {"goldButton":"Style_goldButton__15-oF","fLogo":"Style_fLogo__2aV4M"};